<template>
    <div class="reminder-detail-page">
        <headers :title="from==1?'上课提醒':'应用提醒'"></headers>
        <div class="send_btn" @click="send">发送</div>
        <div class="send-con">
            <template v-if="type==5">
                <div class="send-item msg-item" v-if="from==1">短信通知</div>
                <div class="send-item" v-else
                    :class="method==null?'send-time':''"
                    @click="sentType">{{method==null?'请选择通知方式':method==1?'系统通知':'短信通知'}}</div>
                <div class="send-item"
                    :class="is_schedule==null?'send-time':''"
                    @click="sentTime">{{is_schedule==null?'请选择通知时间':is_schedule==0?'立即发送':`定时发送: ${defaultTimeStr}`}}</div>
            </template>
            <div class="send-item "
                 :class="reminderUnits||stuList?'':'send-unit'"
                 @click="chooseUnit">
                <template v-if="reminderUnits">
                    <span class="class-item"
                          v-for="(item,index) in reminderUnits"
                          :key="index">&lt;{{item.unit_name}}&gt;</span>
                </template>
                <template v-if="stuList">
                    <span class="class-item"
                          v-for="(item,index) in stuList"
                          :key="index">&lt;{{item.unit_name}}({{item.activeStu}}人)&gt;</span>
                </template>
                <template v-if="!reminderUnits&&!stuList">
                    选择接收班级
                </template>
            </div>
            <div class="send-item type_radio">
                <div class="flex">
                    <input type="radio" id="radio1" class="radio" v-model="radio_type" value="5" @change="radio_change">
                    <label for="radio1" class="radio1">书法上课提醒</label><br>
                    <input type="radio" id="radio2" class="radio" v-model="radio_type" value="7" @change="radio_change">
                    <label for="radio2">快乐学习报应用提醒</label><br>
                </div>
            </div>
            <div class="send-item send-text">
                <textarea v-model="content" :placeholder="placeholder" @input="descInput" max-length="200"></textarea>
                <div class="tips">{{content.length}}/{{txtVal}}</div>
            </div>
            <div class="send-item send-img clearfix" v-if="method!=2">
                <div class="pic-item" v-for="(item,index) in imgLists" :key="index">
                    <img @click="previewImg(index)" :src="FILE_VIEW_URLROOT+'/'+item">
                    <i class="icon-close" @click="handleDetail(index)"></i>
                </div>
                <div class="pic-item icon-upload" v-if="imgLists.length<6">
                    <input class="upload_file" @change="uploadImg" type="file" accept="image/*" multiple="multiple">
                    <img src="../img/upload_add.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import headers from 'COMPONENTS/base/header.vue'
    export default {
        components: {
            headers
        },
        data () {
            return {
                type:Number(this.$route.query.type)||5,// 1 作业通知 2 班级通知 3 节日通知 4 考试成绩 5 上课提醒
                //从缓存中读取通知方式
                method: JSON.parse(localStorage.getItem('notice_method'))||2,
                //从缓存中读取已选择的班级
                reminderUnits: JSON.parse(localStorage.getItem('reminderUnits')),
                //从缓存中读取已选择的学生
                stuList: JSON.parse(localStorage.getItem('stuList')),
                //从缓存中读取发送时间
                is_schedule: JSON.parse(localStorage.getItem('is_schedule')),
                //从缓存中读取发送时间 年月日时分
                defaultTime: JSON.parse(localStorage.getItem('defaultTime')),
                //从缓存中读取发送时间 月日时分
                defaultTimeStr: JSON.parse(localStorage.getItem('defaultTimeStr')),
                //短信内容
                content:'',
                //最大输入长度
                txtVal: 200,
                from: this.$route.query.from||0,//1-素质驿站 此时只能发“短信通知”的“上课提醒”
                festival:this.$route.query.festival||"",
                imgLists:[],
                FILE_VIEW_URLROOT: FILE_VIEW_URLROOT,
                placeholder:"请填写通知内容",
                placeholderList:["今天的作业内容","今天的班级通知","今天的节日通知"],
                radio_type:localStorage.getItem('radio_type')||0
            }
        },
        created(){
            if(this.from == 1) this.method = 2
            if(this.type!=5) this.content = ""
            if(this.placeholderList.length >= this.type){
                this.placeholder = this.placeholderList[this.type-1]
            }
            if(this.festival){
                this.content = decodeURIComponent(this.festival)+"一到来，再想一回那放飞的红晴蜓，那会眨眼的小星星，那储存宝贝的玻璃瓶，那独一无二的快乐和纯真吧。给疲惫的心放个假，儿童节快乐!";
            }
            this.radio_change()
        },
        methods: {
            uploadImg (e) {
                let fileLen = e.target.files.length;
                if ((this.imgLists.length + fileLen) > 6) {
                    layer.tips('最多可上传6张图片')
                    return
                }
                layer.open({ type: 2, shadeClose: false, });
                let successCount = 0;
                let upload_key = JSON.parse(localStorage.getItem("info")).upload_key;
                for (let i = 0; i < fileLen; i++) {
                    const form = new FormData();
                    form.append('file', e.target.files[i]);
                    form.append('type', 2);
                    this.$http.post(`${FILE_UPLOAD_URLROOT}/swf_upload/?upcheck=${upload_key}&upType=sffc`, form).then(res => {
                        let data = eval(res.data)
                        let img_url = data[0].file_url;
                        this.imgLists.push(img_url);
                    }).finally(() => {
                        successCount++
                        if (successCount == fileLen) {
                            layer.closeAll()
                        }

                    })
                }
            },
            //删除图片
            handleDetail (index) {
                this.imgLists.splice(index, 1)
            },
            //发送
            send () {
                if(this.type==5){
                    if(this.method == null){
                        layer.tips('请选择通知方式')
                        return
                    }
                    if (this.is_schedule == null) {
                        layer.tips('请选择通知时间')
                        return
                    }
                }
                if (!this.stuList && !this.reminderUnits) {
                    layer.tips('请选择接收班级')
                    return
                }
                if(this.radio_type==0){
                    layer.tips('请选择提醒内容')
                    return
                }
                if (this.content.replace(/\s+/g, "") == '') {
                    layer.tips('请输入通知内容')
                    return
                }
                let url = API_URL_JXGT_API + '/message/send'
                let params = {
                    type: this.radio_type==7?7:this.type,// 1 作业通知 2 班级通知 3 节日通知 4 考试成绩 5 上课提醒 7快乐学习报应用提醒
                    agent: 1,  // 来源  app传1  web 传2
                    place_id: 141,//固定传值
                    content: this.content,
                }
                if(this.type==5){
                    params.method = this.method;// 系统通知传1  短信通知传2
                    params.is_schedule = this.is_schedule; // 0表示实时，1表示定时
                }
                if(this.imgLists.length && this.method==1){
                    params.images = this.imgLists.join(",");
                }
                if (this.is_schedule == 1) {
                    //如果是定时发送，判断所选时间是否小于当前时间，小于则不通过
                    let selectTimps = this.getTimeFormat(this.defaultTime)
                    let nowTimps = Date.now()
                    if (selectTimps <= nowTimps) {
                        layer.tips('定时时间不能小于当前时间')
                        return
                    }
                    params.schedule_time = this.defaultTime.slice(0, 16)  // 定时需要有时间
                } else {
                    //如果是实时发送，则定时时间为空
                    params.schedule_time = ''
                }

                if (this.reminderUnits && !this.stuList) {
                    //如果发送对象为班级
                    let unit_ids = []
                    this.reminderUnits.forEach(e => {
                        unit_ids.push(e.unit_class_id)
                    })
                    params.unit_ids = unit_ids.join(',')
                } else if (this.stuList && !this.reminderUnits) {
                    //如果发送对象为学生
                    var obj = {};
                    this.stuList.forEach(e => {
                        let key = e.unit_class_id;
                        let _arr = []
                        e.students.forEach(j => {
                            if (j.active) {
                                _arr.push(j.user_id)
                            }
                        })
                        obj[key] = _arr.join(',');

                    })
                    params.unit_stu = JSON.stringify(obj)
                }
                this.$http.post(url, params).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips('发送成功')
                        localStorage.removeItem('stuList')
                        localStorage.removeItem('reminderUnits')
                        localStorage.removeItem('is_schedule')
                        localStorage.removeItem('defaultTime')
                        localStorage.removeItem('defaultTimeStr')
                        localStorage.removeItem('radio_type')
                        if(this.type==3){
                            this.$router.go(-2);
                        }else{
                            this.$router.go(-1);
                        }
                        
                    }
                })
            },
            //设置发送方式
            sentType(){
                this.$router.push('/reminder/sendtype')
            },
            //设置发送时间
            sentTime () {
                this.$router.push('/reminder/sendtime')
            },
            //选择接收班级
            chooseUnit () {
                this.$router.push('/reminder/chooseUnit?from='+this.from);
            },
            //输入时触发
            descInput () {
                if ((this.txtVal - this.content.length) < 0) {
                    this.content = this.content.substring(0, 200)
                }
            },
            //年月日转时间戳
            getTimeFormat (timeS) {
                let time = (new Date(timeS).getTime()); //除1000 是变成秒级的时间戳 不除就是毫秒级
                return time;
            },
            previewImg(i){
                let imglist = this.imgLists.map(img=>this.FILE_VIEW_URLROOT+'/'+img);
                this.$imagePreview({
                    images: imglist,
                    index: i,
                    defaultOpt: {
                        bgOpacity: 1,
                        showHideOpacity: true,
                        errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                        tapToClose: true, // 点击上层图层关闭预览
                    }
                });
            },
            radio_change(){
                localStorage.setItem('radio_type',this.radio_type)
                if(this.radio_type==7){
                    this.content='提高学生成绩的关键在于培养自学能力。请引导孩子使用《快乐学习报》进行课程预习和错题订正，以巩固知识。积极参与的学生将有机会获得小礼品！'
                }else if(this.radio_type==5){
                    this.content=`家长好：
        明天上书法课，请提醒孩子带上《硬笔书法练习册》，课堂上要进行书法练习。`
                }
               
            }
        },
    }
</script>

<style lang="scss" scoped>
.send_btn{
    position: fixed;
    top: 0;
    right: 32px/$ppr;
    font-size: 30px/$ppr;
    line-height: 96px/$ppr;
    color: #fff;
    z-index: 10;
    opacity: 0.8;
}
.send-con {
    .send-item {
        padding: 24px / $ppr 48px / $ppr 24px / $ppr 24px / $ppr;
        margin-bottom: 24px / $ppr;
        background: #fff url("../release/img/enter.png") no-repeat 97% center;
        background-size: 14px / $ppr 26px / $ppr;
        .class-item {
            margin-right: 10px / $ppr;
        }
    }
    .send-unit,
    .send-time {
        color: #999;
    }
    .send-text {
        padding: 36px / $ppr 24px / $ppr;
        background: #fff;
        color: #666;
        position: relative;
        textarea {
            width: 100%;
            border: 0;
            min-height: 240px / $ppr;
            font-size: 28px / $ppr;
            line-height: 1.7;
            background: #fff;
        }
        .tips {
            color: #999;
            position: absolute;
            right: 24px / $ppr;
            bottom: 24px / $ppr;
        }
    }
    .msg-item,.send-img {
        background-image: none;
    }
    .send-img{
        padding: 46px/$ppr 36px/$ppr;
        .pic-item{
            float: left;
            width: 212px/$ppr;
            height: 212px/$ppr;
            position: relative;
            &:not(:nth-of-type(3n)){
                margin-right: 6px/$ppr;
            }
            img{
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .upload_file{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                opacity: 0;
                display: block;
            }
            .icon-close{
                position: absolute;
                top: 0;
                right: 0;
                width: 46px/$ppr;
                height: 46px/$ppr;
                background-color: rgba(190,190,190,0.3);
                border-bottom-left-radius: 20px/$ppr;
                background-image: url("../img/delete_icon.png");
                background-size: 18px/$ppr 18px/$ppr;
                background-position: center;
                background-repeat: no-repeat;
            }
        }
    }
    .type_radio{
        background:#fff;
        display: flex;
        align-items: center;
        .flex{
            display: flex;
            align-items: center;
            .radio{
                margin-right: 20px/$ppr;
            }
            .radio1{
                margin-right: 30px/$ppr;
            }
        }
    }
}
</style>